<template>
    <nav>
      <div class="d-grid gap-3 vy-right-nav" >
        <span v-on:click="home()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">HOME</span>
        <!--
        <span v-if="checkin_flg==true" v-on:click="codereader()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">二次元コード読取</span>
        -->
        <span v-on:click="setting()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">設定</span>

        <br><br>

        <p v-on:click="log_out" style="cursor:pointer"><u>ログアウト</u></p>

        <!--  ここでのアカウント削除は行わない  管理者側でアカウント+プロフィルの削除を出来るようにする。 
        <p v-on:click="facility_delete" style="cursor:pointer"><u>アカウント削除</u></p>
        -->

      </div>
    </nav>
</template>

<style scoped>

button{
  padding: 0;
}

</style>

<script setup>
/* eslint-disable */
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check, logout } from '../js/userdata_shisetsu.js'
import { ref } from 'vue'

import axios from 'axios'

const emit = defineEmits(['call'])

login_check()


let route = useRoute()

// 集計画面（埼玉県社協のみ）に入れるかどうか
let syukei = ref(false)

/* 変数の記述 */
let router = useRouter()

// チェックイン機能の利用フラグ
let checkin_flg = ref(false)

const log_out = function() {

    logout()

}

let home = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/'+GlobalData.facility_code+'/Shisetsu')
    //router.push("/"+GlobalData.shakyo+"/"+GlobalData.facility_code+"/Shisetsu").then(() => {
    //    router.go(0)   // ← ページ全体を再ロード（フルリロード）
    //})
}

// 二次元コード（スマホのみ）移動
const codereader = function() {
  //emit('call', { cmd:'readcode'})
  router.push('/'+GlobalData.shakyo+'/'+GlobalData.facility_code+'/Shisetsu/Readcode')
}

// 設定画面表示
const setting = function() {
    // 設定画面表示
    router.push('/'+GlobalData.shakyo+'/'+route.params.shisetsu+'/Shisetsu/setting')
}

import { useStore } from 'vuex'
const store = useStore()
// 検索条件の初期化
let search_param_reset = function(){
    store.state.taikenuser = {}
}

syukei.value = true

// Cognitoユーザーを削除する
let facility_delete = function(){

  emit('call',{ cmd:'facility_delete' })

}

// checkout機能のチェックのために社協データを読み込む
axios.post(GlobalData.$API_URL+"Facility_read", 
    {facility_code:route.params.shisetsu}
    ).then(response => {

      // チェックイン機能の利用  1:利用する、2：利用しない 
      checkin_flg.value = response["data"]["facility_info"].qr_read_flg
})
.catch(error => {
  
//  alert("社協情報の取得時にエラーが発生しました。"+error)
})

</script>


<style scoped>
.btn-default >.badge-notify{
   background:red;
   position:relative;
   top: 7px;
   left: -62px;
}
</style>